export default __webpack_public_path__ + "static/media/ValkyRegular.d79e59cc.ttf";